import React, { useCallback, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { SendRequest } from "../../util/AxiosUtil";

const MembershipPlanTable = () => {
  const [memberships, setMemberships] = useState([]);

  const handleMembershipUpgrade = useCallback((membership, option) => {
    //Paypal Integration Code here
    SendRequest({
      url: "MembershipManage/_UpdateMembership",
      method: "POST",
      data: {
        MembershipPlanId: membership.PlanId,
        BillingPeriod: option,
      },
    }).then((result) => {
      if (result.data === true) {
        alert("Successfully Updated");
        window.location.reload();
        //fetchAsset();
      }
    });
    //setOpen(false);
  }, []);

  useEffect(() => {
    const fetch = async () => {
      const promise = SendRequest({
        url: "MembershipManage/_GetAllMemberShips",
        method: "POST",
      });
      // Defensive: handle case where SendRequest returns undefined (mocked tests)
      if (promise && typeof promise.then === 'function') {
        promise.then((result) => {
          if (result && Array.isArray(result.data)) {
            setMemberships(result.data);
          }
        }).catch(() => {
          // Silently handle API errors for memberships fetch
        });
      }
    };
    fetch();
  }, []);

  return (
    <div className="container">
      <h2 className="mb-3">Membership Plans</h2>
      <div className="row g-3">
        {memberships.map((membership, index) => (
          <div key={index} className="col-12 col-md-4">
            <div className="card membership-plan-card h-100">
              <div className="card-body d-flex flex-column">
                <h4 className="card-title">{membership.Name}</h4>
                <p className="card-text text-muted">{membership.Description}</p>
                <div className="mt-auto">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="text-muted">Monthly:</span>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleMembershipUpgrade(membership, 0)}
                    >
                      {index === 0
                        ? "Sign Up Now(Free)"
                        : `${membership.Month_Value_In_Cash}`}
                    </Button>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-muted">Annual:</span>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => handleMembershipUpgrade(membership, 1)}
                    >
                      {index === 0
                        ? "Sign Up Now(Free)"
                        : `${membership.Annual_Value_In_Cash}`}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-2 ms-2">
        *based on an average 2-hour game of 5 players. Longer games and more
        players add to the cost.
      </p>
    </div>
  );
};

export default MembershipPlanTable;
